import type { ReceivedBidDto } from "../../../autogen/bff-api";

export const bidDocuments = (bid: ReceivedBidDto) =>
  [
    ...(bid.documents ?? []),
    ...((bid.qualificationResponses ?? []).flatMap((response) => response.evidenceDocuments ?? [])),
  ].filter((document, index, documents) => documents.findIndex((d) => d.id === document.id) === index);
